import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import SettingsTable from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/settingsTable';
import ActionsTable from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/actionsTable';
import YoutubeVideoCardAlarm from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/YoutubeVideoCardAlarm';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Alarm Menü // Alarm Aktionen",
  "path": "/Web_User_Interface/1440p_Serie/Alarm/Aktionen/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Legen Sie fest, was Ihre Kamera im Alarmfall machen soll. Bestimmen Sie hier welche Aktionen die Kamera ausführen soll, wenn ein Alarmereignis ausgelöst wurde.",
  "image": "./WebUI_1440p_SearchThumb_Alarm_Alarm_Actions.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Alarm_Alarm_Actions.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Alarm Menü // Alarm Aktionen' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Legen Sie fest, was Ihre Kamera im Alarmfall machen soll. Bestimmen Sie hier welche Aktionen die Kamera ausführen soll, wenn ein Alarmereignis ausgelöst wurde.' image='/images/Search/WebUI_1440p_SearchThumb_Alarm_Alarm_Actions.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Alarm_Alarm_Actions.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Alarm/Actions/' locationFR='/fr/Web_User_Interface/1440p_Series/Alarm/Actions/' crumbLabel="Alarm Actions" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "alarm-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarm-men%C3%BC",
        "aria-label": "alarm menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Menü`}</h2>
    <h3 {...{
      "id": "alarm-actions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#alarm-actions",
        "aria-label": "alarm actions permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Actions`}</h3>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "was-wollen-sie-ihre-kamera-im-alarmfall-machen-lassen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#was-wollen-sie-ihre-kamera-im-alarmfall-machen-lassen",
        "aria-label": "was wollen sie ihre kamera im alarmfall machen lassen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Was wollen Sie Ihre Kamera im Alarmfall machen lassen?`}</h2>
    <p>{`Stellen Sie das Verhalten der Kamera im Fall eines Alarms der Bewegungserkennung ein. Sie können Ihre Kamera Emails senden lassen oder Snapshots und Videos auf Ihre SD-Karte speichern lassen. Bitte stellen Sie sicher, dass Sie Ihre `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Features/Email_Einstellungen/"
      }}>{`SMTP Server Einstellungen`}</a>{` eintragen, bevor Sie die `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Aktionen/"
      }}>{`Email Benachrichtigung`}</a>{` aktivieren und stellen Sie sicher, dass Sie eine SD-Karte in Ihrem SDHC Kartenslot eingesteckt haben (max. 32 GB) um die `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Aktionen/"
      }}>{`Videoaufnahme-Funktion`}</a>{` und die `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Features/FTP/"
      }}>{`Send-To-FTP Aktion`}</a>{` nutzen zu können - eine 4 GB SD Karte ist im Lieferumfang erhalten.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/4a71ea1c22f8c491c129f27b6afb374b/121b3/1440p_Settings_Alarm_Actions_Settings.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.043478260869556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACgElEQVQoz1WRS08TURSA+QtGTRQ1Gha2tFY0hJeBRvuaTul05s698+y0IKI0QR7y8BkVDBpB0MTH3qWgGxcm7PwPblz4Yz4zrQRZnNzcnHO/851zuzKZDMnERcrTG5jPf1B99BXt/h65pS+dWN4lv7JLYeXoqa1+wXu5j9Xa4Mypk3R3n6Gnp4euVDpNMpFAD2bxl96h5jbxFrdpPvzI1ONPNFd2cOa38BZ38Jfe4i5sI+e2cOe3iFbfo3szZNKX6OvrJ5PpoyudTtPbmyJ/fQzHqiCqJZRZIZQGYWOSsPUAR1pIQ0PWdGStjG2UqWo5KsUshj5OrRaSu6ExODByAOylWCoRhHUc18NWDpZpYE0uIx58RgY38VwX1wvaeakchJBY0kbVAhx9glK+wPDwcAeYTCYpFouEYYjnebgxtDaO3VpDvvqJjG7jORLP91FKYVkWjUaDyelpWo7ixZSP4xQYGR48BBYKBXw/Tjgox0UYOmphB/fDb1SjhatEx962EUIQBgFBGDF3O2L7mYenxhgZGjocOQbGdrGBlApbmJj+FNWJVSzpYQsL8Q8WQ6WUaFqZzdev2P/8BlUZZWBg6OjI9Xod13XbxfFDJQWBI7CFaMNsW2LHzWwbV0oqeoXNtef8+bbHPafK1f7+o4YxLDY8GMs0TQyj1t5ZfLcMHTFeomYa6EqSrVTYWX/Kr/3vvJ1xyGX/M9Q0jWazSVSvtz8nBscriKKos1cp8WbXcVffM9O4yzvDZH3cZG5qgiezt4jK1xgdukJXKpUikUiQzWbbRrquUy6X2w1KpVI7Yvt8Pk9RTFLwZzF1m5mxLHdyRfouX+bY8ROcPnuO8+cv8BenKrE7rIUBAgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4a71ea1c22f8c491c129f27b6afb374b/e4706/1440p_Settings_Alarm_Actions_Settings.avif 230w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/d1af7/1440p_Settings_Alarm_Actions_Settings.avif 460w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/7f308/1440p_Settings_Alarm_Actions_Settings.avif 920w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/07541/1440p_Settings_Alarm_Actions_Settings.avif 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/4a71ea1c22f8c491c129f27b6afb374b/a0b58/1440p_Settings_Alarm_Actions_Settings.webp 230w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/bc10c/1440p_Settings_Alarm_Actions_Settings.webp 460w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/966d8/1440p_Settings_Alarm_Actions_Settings.webp 920w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/893d8/1440p_Settings_Alarm_Actions_Settings.webp 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4a71ea1c22f8c491c129f27b6afb374b/81c8e/1440p_Settings_Alarm_Actions_Settings.png 230w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/08a84/1440p_Settings_Alarm_Actions_Settings.png 460w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/c0255/1440p_Settings_Alarm_Actions_Settings.png 920w", "/de/static/4a71ea1c22f8c491c129f27b6afb374b/121b3/1440p_Settings_Alarm_Actions_Settings.png 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/4a71ea1c22f8c491c129f27b6afb374b/c0255/1440p_Settings_Alarm_Actions_Settings.png",
              "alt": "Web User Interface - 1080p Series - Alarm Actions",
              "title": "Web User Interface - 1080p Series - Alarm Actions",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <SettingsTable mdxType="SettingsTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "softwarebasierte-bewegungserkennung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#softwarebasierte-bewegungserkennung",
        "aria-label": "softwarebasierte bewegungserkennung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Softwarebasierte Bewegungserkennung`}</h3>
    <p>{`Die softwarebasierte Bewegungserkennung, die von Ihrer Kamera für die aktivierten `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Bereiche/"
      }}>{`Alarm Bereiche`}</a>{` genutzt wird, benötigt keine zusätzliche Hardware und kann in kontrollierten Innenräumen sehr präzise arbeiten. Der Nachteil ist, dass die Kamera keine Unterschiede macht und zum Beispiel eine vorbeiziehende Wolke ebenso ein Alarm auslösen wird, wie ein Mensch. Alles kann einen Alarm auslösen.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardAlarm mdxType="YoutubeVideoCardAlarm" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "den-internen-sensor-der-kamera-nutzen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#den-internen-sensor-der-kamera-nutzen",
        "aria-label": "den internen sensor der kamera nutzen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Den internen Sensor der Kamera nutzen`}</h3>
    <p>{`Das Aktivieren des internen oder externen PIR Sensors begrenzt die Bewegungserkennung auf Objekte deren Temperatur sich vom Hintergrund unterscheidet. In den meisten Fällen wird das ein Mensch oder ein Tier vor der Kamera sein, sowie der warme Motor des Autos. Änderungen der Lichtverhältnisse oder Nebel vor der Kamera werden vom PIR Sensor nicht erfasst.`}</p>
    <p>{`Durch das Koppeln des PIR Sensors mit den Alarmbereichen, erhalten Sie nur einen Alarm, wenn beide Methoden zur selben Zeit auslösen. Dies wird die Anzahl Ihrer Fehlalarme, falls Sie welche haben, stark reduzieren. Bitte beachten Sie auch, dass es auch dazu führen kann, dass positive Alarme nicht erfasst werden.`}</p>
    <h3 {...{
      "id": "einen-externen-sensor-nutzen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#einen-externen-sensor-nutzen",
        "aria-label": "einen externen sensor nutzen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Einen externen Sensor nutzen`}</h3>
    <p>{`Sie können einen Bewegungsmelder wie den `}<a parentName="p" {...{
        "href": "/de/Produkte/IN-Motion/500/"
      }}>{`IN-MOTION 500`}</a>{` nutzen, um die Erkennung Ihrer Kamera zu verbessern (Nur Kameras mit einem Alarm-In Anschluss), wenn Ihre Kamera keinen eingebauten PIR Bewegungssensor verbaut hat. `}<a parentName="p" {...{
        "href": "/de/Produkte/IN-Motion/500/Verkabelung/"
      }}>{`Verbinden Sie einfach den Sensor`}</a>{` mit dem Alarm Eingang und aktivieren Sie den externen Eingang. Die Kamera wird einen Alarm auslösen, wenn die Pins 3&4 überbrückt sind und das Relais auf Alarm geschlossen ist. Wenn es auf geöffnet bei Alarm gesetzt ist, wird der Alarm ausgelöst, sobald der Stromkreis durch das Relais im Detektor unterbrochen wird (n.c. "Normal geschlossen") oder wenn der Draht nicht angeschlossen ist. Der Zustand, den Sie wählen müssen, hängt von Ihrem Sensor ab - die falsche Wahl gibt einen kontinuierlichen Alarm aus, sobald der Melder angeschlossen ist.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/a281549e5b7660dc3ecb927f7835f4dc/024d6/1440p_Settings_Alarm_Actions_Actions.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.60869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAC2ElEQVQ4y2WTTW9bRRSG8yOQUIniJtmEJE6J08QBJbZjO2nt6/sxM3fu3E/no2lCFxQEaiWE2LRQqEopYs1PYEuQWLCGf/WgGSduQhev7mg088x73nPuTL1eZ2VlhXp9jb2TF3TPf6Vz+pqdk1dT7V7q7fondo5eEnz1G20v5db77/HB7Czz8/PMWODy8jJra3eonv1O+eNflD/8ifnurfTzC5LnF25tv/rZH+QvLjj75W9a/pjF23MsLS2ztPQhM9adlYV6gwNE4BH5A2Q4IlEhWgZoETAuDA8OC46qzO2JYIgIPXrdPq3dLp32PltbHzOzurrKFVRISZblJMYQxzGRkAy9EUJIiqIky3NMmhJrjR+EeJ7Pvf592q0unVZ/Arzu0ELKsiTPc5IkIQxDep0dRt7A7aVpijEGpWL80ZDhvT6jwQG9bo+2BW5ec2iBURReXlBIKRCxITx5isiOSY0mSYx7SEmByh+QnD5BqQF77bYDNm86XEFpQ1EUJIlGKYlKcsxn36Orc/LMuDhinSD9AfEXbzCv/8UPfLrtFvu9HtvN7Zslq7SiHB+SV0cYk0xkGxPbbFNXtkkzB1Sf/4x+9Q9Dz6ff2eWg36W59T9grCRFWaHzQ7SOXemjkU8UhmRFRZpNcoylIK7Oic++oYwD7vf26Hf3aTY/mcyhzdEBtXZN0bG6zFHieR5RFJEff+oey9LUTYHRikQJklGX7c0GGxubrNXvTBxeNcYG7soyxjnRWjt3MjbkR+eURUaaZe6cbZDN9KP1BrPuL7ntNC3ZyrqyTbkaGyGEg9tG6OxwCrIPJVqTGsPduxvUajUWFxdZWFi4CbSXq6qazpwFZFnmAFIIZBQggyGRCPGUJNSaRqPB3Nycg90A2rLtINvhttlZt9dl9+LxI9TZ14zTY574AY+FYn19nbla7V2gVRAE08vXdTXo+vQp8ZdveFg84qU34tvwXeB/3bgzL3SueYEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a281549e5b7660dc3ecb927f7835f4dc/e4706/1440p_Settings_Alarm_Actions_Actions.avif 230w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/d1af7/1440p_Settings_Alarm_Actions_Actions.avif 460w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/7f308/1440p_Settings_Alarm_Actions_Actions.avif 920w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/7733b/1440p_Settings_Alarm_Actions_Actions.avif 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/a281549e5b7660dc3ecb927f7835f4dc/a0b58/1440p_Settings_Alarm_Actions_Actions.webp 230w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/bc10c/1440p_Settings_Alarm_Actions_Actions.webp 460w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/966d8/1440p_Settings_Alarm_Actions_Actions.webp 920w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/85db8/1440p_Settings_Alarm_Actions_Actions.webp 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a281549e5b7660dc3ecb927f7835f4dc/81c8e/1440p_Settings_Alarm_Actions_Actions.png 230w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/08a84/1440p_Settings_Alarm_Actions_Actions.png 460w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/c0255/1440p_Settings_Alarm_Actions_Actions.png 920w", "/de/static/a281549e5b7660dc3ecb927f7835f4dc/024d6/1440p_Settings_Alarm_Actions_Actions.png 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/a281549e5b7660dc3ecb927f7835f4dc/c0255/1440p_Settings_Alarm_Actions_Actions.png",
              "alt": "Web User Interface - 1080p Series - Alarm Actions",
              "title": "Web User Interface - 1080p Series - Alarm Actions",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ActionsTable mdxType="ActionsTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      